import React from 'react'
import { Link } from 'react-router-dom'

export default function Header() {
    return (
        <nav className="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
            <Link className="navbar-brand col-sm-3 col-md-2 mr-0" to="#">Lead Management Tool v1.0.0</Link>
            <ul className="navbar-nav px-3">
                <li className="nav-item text-nowrap">
                <Link className="nav-link" to="/">Sign out</Link>
                </li>
            </ul>
        </nav>
    )
}
